jQuery(function ($) {
  // Si on n'a qu'un accordéon dans la page, on l'active par défaut
  if ($('.accordion .accordion-item').length == 1) {
    $('.accordion .accordion-item .accordion-button').trigger('click');
  };
});
document.addEventListener("DOMContentLoaded", function () {
    // Charger le megamenu à partir du <template>
    let loaded = false;
    document.getElementById('megamenu').addEventListener('show.bs.collapse', event => {
        if (!loaded) {
            let template = document.querySelector("#megamenu-template");
            let megamenuContents = document.importNode(template.content, true);
            document.getElementById('megamenu').appendChild(megamenuContents);
            loaded = true;
        }
    });


  const portalsRow = document.querySelector('.portails__row');
  const headerRow = document.querySelector('.header__row');
  const scrollThreshold = 50;

  if (!portalsRow && !headerRow) return;

  function handleScroll() {
    const isScrolledPast = window.scrollY > scrollThreshold;

    if (portalsRow) {
      portalsRow.classList.toggle('is-fixed', isScrolledPast);
    }

    if (headerRow) {
      headerRow.classList.toggle('is-fixed', isScrolledPast);
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });

  // Appel initial pour gérer l'état au chargement de la page
  handleScroll();
});

// Modifier les attributs des boutons d'accordéon en fonction de la taille de l'écran 
document.addEventListener('DOMContentLoaded', function () {
  const toolsAccordion = document.getElementById('toolsAccordion');
  if (!toolsAccordion) return;
  const mql = window.matchMedia('(max-width: 1024px)');


    const accordionButtons = toolsAccordion.querySelectorAll('.accordion-button');
    const accordionCollapses = toolsAccordion.querySelectorAll('.accordion-collapse');

    if (mql.matches) {
      // Mobile view
      accordionButtons.forEach(button => {
        button.setAttribute('data-bs-toggle', 'collapse');
      });
      accordionCollapses.forEach(collapse => {
        collapse.classList.remove('show');
      });
    } else {
      // Desktop view
      accordionButtons.forEach(button => {
        button.removeAttribute('data-bs-toggle');
      });
      accordionCollapses.forEach(collapse => {
        collapse.classList.add('show');
      });
    }

});

document.addEventListener("DOMContentLoaded", function () {
  const logo = document.querySelector('.cta-side__socials');
  // On cible directement le footer (ou l'élément avec data-theme="dark")
  const darkSection = document.querySelector('[data-theme="dark"]');

  if (!logo || !darkSection) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Le footer est visible sous le logo -> Logo Blanc
        logo.classList.add('is-light');
        logo.classList.remove('is-dark');
      } else {
        // Le footer n'est plus visible -> Logo Noir (par défaut)
        logo.classList.add('is-dark');
        logo.classList.remove('is-light');
      }
    });
  }, {
    // Déclenche le changement dès que le footer croise la ligne médiane de l'écran
    rootMargin: "-30% 0px -30% 0px",
    threshold: 0
  });

  observer.observe(darkSection);
});